import React, { Component } from 'react'
import DemoCarousel from './headerCarosal'
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import AboutUs from '../components/aboutUs';
import Services from '../components/services';
import Portfolio from '../components/portfolio';
import Testimonials from '../components/testimonials';
import DesignCollection from '../components/DesignCollection';
import Partners from './Partners';



import Mission from './mission';
import Contact from './contact';

export default class middleSection extends Component {
    render() {
        return (
            <>
                <div id="home" className="section-padding">
                    <DemoCarousel></DemoCarousel>
                </div>
                <div id="about" className="section-padding-consistent">
                    <AboutUs></AboutUs>
                </div>
                {/* Mission section commented out */}
                {/*
                <div className="section-padding-consistent">
                    <Mission></Mission>
                </div>
                */}
                <div id="services" className="section-padding-consistent">
                    <Services></Services>
                </div>
                {/*}
                <div id="portfolio" className="section-padding-consistent">
                    <Portfolio></Portfolio>
                </div>
                */}
                <div id="design-collection" className="section-padding-consistent">
                    <DesignCollection />
                </div>                
                <div id="testimonials" className="section-padding-consistent">
                    <Testimonials></Testimonials>
                </div>
                <div className="section-padding-consistent">
                    <Partners></Partners>
                </div>
                <div id="contact">
                    <Contact></Contact>
                </div>
            </>
        )
    }
}